module.exports = __webpack_public_path__ + "img/Unit_Guide_wine_large.57c4d0b1.svg";